import { Injectable } from '@angular/core';
import {HttpService} from "./http.service";
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { UserService } from './user.service';
import * as moment from 'moment/moment';

import 'rxjs/add/operator/toPromise';
import {Machine} from "../models/machine";
import {User} from "../models/user";
import {Account} from "../models/account";
import {AccountAdd} from "../models/account-add";

@Injectable()
export class AccountService {
    private accountCache: Account[]
    private accountCacheExpiration: any
    accountMap: any

    constructor(
        private httpService: HttpService,
        private toastr: ToastsManager,
        private userService: UserService
    ) {
        this.accountCache = null;
        this.accountMap = null;
        this.accountCacheExpiration = null;
    }

    machines(): Promise<Machine[]> {
        let me = this;
        return this.httpService.get(`/Accounts/${this.userService.accountId}/machines`, {
            'filter[include][hubModules]': 'slots'
        })
            .then(function(results: any){
                var machines: Machine[] = [];
                for (let result of results) {
                    var machine: Machine = new Machine().fromJson(result);
                    machines.push(machine);
                }
                return machines
            })
            .catch(function(error: any){
                me.httpService.handleError(error, "Unable to retrieve Machines for your Account")
            })
    }

    users(): Promise<User[]>{
        let me = this;
        /* tslint:disable */
        let params = {
          filter: JSON.stringify({"include": { "assignedMachines": "machine" }})
        };
        let url = `/Accounts/${me.userService.accountId}/users`;

        if (me.userService.isSuper) {
            url = `/ZMUsers`;
        }
        /* tslint:enable */
        return this.httpService.get(url, params)
        .then(function(results: any){
            let users: User[] = [];
            for (let result of results) {
                var user: User = new User().fromJson(result);
                if (me.accountMap) {
                    user.account = me.accountMap[user.accountId];
                }
                users.push(user)
            }
            return users
        })
        .catch(function(error: any) {
            me.httpService.handleError(error, "Unable to retrieve Users for your Account")
        })
    }

    getAccount(accountId): Promise<Account> {
        let me = this;
        return this.httpService.get(`/Accounts/${accountId}`, {})
            .then(function(result: any){
                let account:Account = new Account().fromJson(result);
                me.userService.accountName = account.name;
                return account
            })
            .catch(function(error: any) {
                me.httpService.handleError(error, "Unable to retrieve account for user")
            })
    }

    getAccounts(): Promise<Account[]> {
        let me = this;
        let needsRefresh = !this.accountCache || !this.accountCacheExpiration || this.accountCacheExpiration.isBefore(moment());
        if (needsRefresh) {
            return this.httpService.get(`/Accounts`, {})
                .then(function(results: any){
                    let accounts: Account[] = [];
                    me.accountMap = {};
                    for (let result of results) {
                        let account: Account = new Account().fromJson(result);
                        me.accountMap[account.id] = account;
                        accounts.push(account)
                    }
                    me.accountCache = accounts
                    me.accountCacheExpiration = moment().add(3, 'minutes')

                    return accounts
                })
                .catch(function(error: any) {
                    me.httpService.handleError(error, "Unable to retrieve account for user")
                })
        } else {
            return Promise.resolve(this.accountCache);
        }
    }

    addAccount(accountAdd:AccountAdd): Promise<Account> {
        let me = this;

        return this.httpService.post('/Accounts/createWithAdminUser', accountAdd)
            .then(function (result:any) {
                me.toastr.success(`Account ${accountAdd.name} created successfully`);
                return new Account().fromJson(result);
            })
            .catch(function (error:any) {
                me.httpService.handleError(error, "Account creation failed. Please ensure Account name and Administrator email are unique.");
            });
    }

}



// WEBPACK FOOTER //
// ./src/app/services/account.service.ts